import moment from 'moment'

export const getters = {
	// isUser: state => (state.user !== null),
  isAuthenticated: state => state.token !== null,
  isSuperAdmin: state => state.roles.indexOf("ROLE_SUPER_ADMIN") !== -1,
  user: state => state,
  officeId: state => state.officeId,
  isTokenExpired: (state) => state.token_duration && moment(state.token_duration) <= moment(),
	// advisors: state => state.user && state.user.advisors
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/getters.js